import { ManagementLayout } from '../Layouts';
import { ManagementBrowserRouter } from '../Routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { DrawerGlobal, ModalGlobal } from '@esg/ui';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    },
  },
});


const App: React.FC = () => {

  return (
    <QueryClientProvider client={queryClient}>
      <DrawerGlobal />
      <ModalGlobal />
      <ManagementBrowserRouter>
        <ManagementLayout />
      </ManagementBrowserRouter>
    </QueryClientProvider>
  );
};

export default App;
